import { Injectable } from '@angular/core';
import { Logger, StreamSubject } from '@iese-chatbot/common-utils';
import { interval, Observable, Subject, takeUntil } from 'rxjs';
import { XhrService } from './xhr.service';

@Injectable({ providedIn: 'root' })
export class XhrMockService implements XhrService {
  private tokensMock: string[] = [
    'This i',
    's a m',
    'ocked re',
    'ply',
    '.\n\n\n',
    // loremIpsum, // desde el mock en el archivo `chat.mock.ts`
    '\n',
    'No a',
    'ctu',
    'al c',
    'all has',
    ' bee',
    'n ma',
    'de t',
    'o Azu',
    're Ope',
    'nAI.',
    '\n',
    'The',
    ' c',
    'alculat',
    'ed',
    ' va',
    'lue',
    ' is',
    ' \\[',
    '\n VAN = \\su',
    'm_{t=0}^{',
    'n} \\frac{F',
    '_t}{',
    '(1 + r)^t} - ',
    'I_0',
    ' \\]',
  ];
  private emissionInterval = 250; // Tiempo entre cada token (en ms)
  private stop$ = new Subject<void>();

  xhrConnection(url: string, message: any, files: File[]): Observable<StreamSubject> {
    Logger.mock('mocking xhrConnection with the following url, message and files:', url, message, files);
    const subject = new Subject<StreamSubject>();
    let emittedSoFar = '';

    interval(this.emissionInterval)
      .pipe(takeUntil(this.stop$))
      .subscribe((index) => {
        if (index < this.tokensMock.length) {
          emittedSoFar += this.tokensMock[index];
          subject.next({ message: emittedSoFar, citations: [] });
        } else {
          subject.complete();
          this.stop$.next();
          this.stop$.complete();
        }
      });

    return subject.asObservable();
  }

  stopStream(): void {
    this.stop$.next();
    this.stop$.complete();
  }
}
